// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__aTNSm","description":"style_description__S64Iv","extras":"style_extras__SkzVq"};